import React, { useState, useEffect } from 'react';

const GoogleTranslate = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState({ name: 'Select Language', flag: '' });

  const languages = [
    { code: 'en', name: 'English', flag: 'us' },
    { code: 'es', name: 'Spanish', flag: 'es' },
    { code: 'fr', name: 'French', flag: 'fr' },
    // Add more languages as needed
  ];

  const languageMap = {
    en: { name: 'English', flag: 'us' },
    es: { name: 'Spanish', flag: 'es' },
    fr: { name: 'French', flag: 'fr' },
    // Add more languages as needed
  };

  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language);
    setIsDropdownOpen(false);

    const selectElement = document.querySelector('.goog-te-combo');
    if (selectElement) {
      selectElement.value = language.code;
      selectElement.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  useEffect(() => {
    const selectElement = document.querySelector('.goog-te-combo');
    if (selectElement) {
      const selectedCode = selectElement.value;
      setSelectedLanguage(languageMap[selectedCode] || { name: 'Select Language', flag: '' });
    }
  }, []);

  return (
    <div className="language-dropdown">
      <div className="custom-dropdown ml-2">
        <div className="selected-language notranslate" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
          {selectedLanguage.flag && (
            <span className={`flag-icon flag-icon-${selectedLanguage.flag} mr-2`} />
          )}
          {selectedLanguage.name}
          <img src={'dropdown.png'} alt="" className="img-fluid language-dropdown-icon" />
        </div>
        {isDropdownOpen && (
          <ul className="language-list notranslate">
            {languages.map((language) => (
              <li key={language.code} onClick={() => handleLanguageSelect(language)}>
                <span className={`flag-icon flag-icon-${language.flag} mr-2`} />
                {language.name}
              </li>
            ))}
          </ul>
        )}
      </div>
      <div id="google_translate_element_web" style={{ display: 'none' }}></div>
    </div>
  );
};

export default GoogleTranslate;
